import React from 'react'
import { ITwoFaLoginUserInput } from 'app/shared/data-access/users/two-fa-login-user/ITwoFaLoginUserInput'
import { UserRepository } from 'app/shared/data-access/users'
import { useUserContext } from 'app/shared/state/user-context'
import TwoFaUserLoginEmailView from './two-fa-user-login-email-view'
import { useHistory } from 'react-router-dom'
import { useToastContext } from 'app/shared/state/toast-context'
import TwoFaUserLoginTotpView from './two-fa-user-login-totp-view'


const TwoFaUserLogin = () => {
  const history = useHistory()
  const { reloadCurrentUser } = useUserContext()
  const { addToast } = useToastContext()

  const params = new URLSearchParams(window.location.search)

  const email = params.get('email')
  const totp = params.get('totp')

  /**
   * uses twoFaCode from login function to authenticate
   * @param {ITwoFaLoginUserInput} input
   */
  const twoFaLogin = async (input: ITwoFaLoginUserInput) => {
    if (email) {
      input.email = email!
    }
    const twoFaLoginResult = await UserRepository.twoFaLoginUser(input)

    if (twoFaLoginResult.error) {
      addToast({
        variant: 'error',
        message: 'Kan niet inloggen, de code is onjuist'
      })
      return
    }

    const jwtToken = twoFaLoginResult.data?.token!

    localStorage.setItem('token', jwtToken)

    await reloadCurrentUser()
    history.push('/')
  }

  return totp === null ? <TwoFaUserLoginEmailView onTwoFaLogin={twoFaLogin} /> : <TwoFaUserLoginTotpView onTwoFaLogin={twoFaLogin} />
}

export default TwoFaUserLogin
